<script setup lang="ts">
import LeEmail from "@dsk/icons/LeEmail.vue";
import LeFacebook from "@dsk/icons/LeFacebook.vue";
import LeInstagram from "@dsk/icons/LeInstagram.vue";
import LeLinkedin from "@dsk/icons/LeLinkedin.vue";
import LeLogoOrdbogen from "@dsk/icons/LeLogoOrdbogen.vue";
import LePhone from "@dsk/icons/LePhone.vue";
import LeYoutube from "@dsk/icons/LeYoutube.vue";
import { useI18n } from "vue-i18n";

import { config } from "@/config";

/* eslint-disable @intlify/vue-i18n/no-raw-text */

const { t } = useI18n();

const { language } = config.app;
</script>

<template>
  <footer class="le-sikker-teknologi-footer">
    <section class="le-sikker-teknologi-footer__main">
      <div class="le-sikker-teknologi-footer__company-info">
        <LeLogoOrdbogen />
        <div>
          Ordbogen A/S
          <br />
          Billedskærervej 8
          <br />
          5230 Odense M
        </div>
        <div>CVR-nr. 26 40 40 37</div>
      </div>

      <div class="le-sikker-teknologi-footer__policies">
        <a :href="`/${language}/policies/`">Cookie- og privatlivspolitik</a>
      </div>

      <div class="le-sikker-teknologi-footer__products le-sikker-teknologi-footer__list-section">
        <b class="le-sikker-teknologi-footer__list-section-heading">Produkter</b>
        <a href="//www.ordbogen.com" target="_blank">Ordbogen.com</a>
        <a href="//www.grammatip.com" target="_blank">Grammatip.com</a>
        <a href="//abc.ordbogen.com" target="_blank">abc.ordbogen.com</a>
      </div>

      <div class="le-sikker-teknologi-footer__contact le-sikker-teknologi-footer__list-section">
        <b class="le-sikker-teknologi-footer__list-section-heading">Kontakt</b>
        <div class="le-sikker-teknologi-footer__contact-option">
          <LePhone role="presentation" />
          +45 6612 6000
        </div>
        <div class="le-sikker-teknologi-footer__contact-option">
          <LeEmail role="presentation" />
          <a href="mailto:support@ordbogen.com" target="_blank">support@ordbogen.com</a>
        </div>
      </div>

      <div class="le-sikker-teknologi-footer__data-protection">
        <i>Certificeret i sikker datahåndtering af</i>
        <img
          src="@/assets/img/gdpr/gt-badge-white.png?halfSize"
          srcset="@/assets/img/gdpr/gt-badge-white.png 2x"
          alt="Grant Thornton ISAE 3000 GDPR 2024"
        />
      </div>

      <div class="le-sikker-teknologi-footer__socials">
        <a
          href="https://www.facebook.com/ordbogen/"
          :aria-label="t('le-expanded-footer.socials.facebook-label')"
          target="_blank"
        >
          <LeFacebook role="presentation" />
        </a>
        <a
          href="https://www.instagram.com/ordbogencom/"
          :aria-label="t('le-expanded-footer.socials.instagram-label')"
          target="_blank"
        >
          <LeInstagram role="presentation" />
        </a>
        <a
          href="https://www.linkedin.com/company/ordbogen-a-s/"
          :aria-label="t('le-expanded-footer.socials.linkedin-label')"
          target="_blank"
        >
          <LeLinkedin role="presentation" />
        </a>
        <a
          href="https://www.youtube.com/channel/UCnABCeeR5L0i34R4enGrdWw/"
          :aria-label="t('le-expanded-footer.socials.youtube-label')"
          target="_blank"
        >
          <LeYoutube role="presentation" />
        </a>
      </div>
    </section>
  </footer>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all.less";

.le-sikker-teknologi-footer {
  background: #2561b3;
  color: white;
  text-align: center;

  #media-breakpoint-up(lg, {
    padding-top: 30px;
  });

  a {
    color: white;
    text-decoration: underline;
  }

  &__main {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 28px;
    padding-bottom: 32px;

    #media-breakpoint-up(lg, {
      display: grid;
      grid-template-areas:  "company-info products contact data-protection"
                            "policies policies policies socials";
      align-items: flex-start;
      text-align: start;

      @padding-x: 1.5rem * 0.5;
      padding: 16px @padding-x 16px @padding-x;
    });
  }

  &__company-info {
    display: flex;
    grid-area: company-info;
    flex-direction: column;
    gap: 12px;
    line-height: 22px;
  }

  &__policies {
    grid-area: policies;
  }

  &__products {
    grid-area: products;
  }

  &__contact {
    grid-area: contact;
  }

  &__list-section {
    display: flex;
    flex-direction: column;
    gap: 8px;

    &-heading {
      margin-bottom: 4px;
    }
  }

  &__contact-option {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    #media-breakpoint-up(lg, {
      justify-content: flex-start;
    });
  }

  &__data-protection {
    .body-text("xs");
    display: flex;
    grid-area: data-protection;
    flex-direction: column;
    gap: 16px;
    max-width: 213px;
    color: white;
    justify-self: flex-end;
  }

  &__socials {
    display: flex;
    grid-area: socials;
    gap: 9px;
    margin-bottom: 4px;
    justify-self: flex-end;
  }
}
</style>
